import { constants, locale, formatDollarsStandard } from '@trqk/utils';

const { API_ERROR_MESSAGES } = constants;

export const getLogEventErrorMessage = (event: LogEvent): string => {
    const statusMessage = event?.detail?.status_message ?? '';

    let capitalizedStatusMessage = statusMessage;

    if (statusMessage.length > 0) {
        const firstChar = statusMessage[0].toUpperCase();
        const afterFirstChar = statusMessage.slice(1);

        capitalizedStatusMessage = `${firstChar}${afterFirstChar}`;
    }

    let errorMessage = capitalizedStatusMessage;

    const qrrOverage = event?.detail?.qrr_overage ?? null;
    const qrrCapacity = event?.detail?.qrr_capacity ?? null;
    const statementEarnings = event?.detail?.statement_earnings ?? null;

    if (statusMessage.includes(API_ERROR_MESSAGES.DUPLICATE_OF_STATEMENT)) {
        errorMessage = API_ERROR_MESSAGES.STATEMENT_PREVIOUSLY_ADDED;
    } else if (
        qrrOverage !== null &&
        qrrOverage > 0 &&
        qrrCapacity !== null &&
        statementEarnings !== null
    ) {
        errorMessage = `${
            locale.enUS.INGESTION.ERRORS.QRR_EXCEEDED.EARNINGS_OF
        } ${formatDollarsStandard(statementEarnings)} ${
            locale.enUS.INGESTION.ERRORS.QRR_EXCEEDED.WOULD_EXCEED_CAPACITY_OF
        } ${formatDollarsStandard(qrrCapacity)} ${
            locale.enUS.INGESTION.ERRORS.QRR_EXCEEDED.BY
        } ${formatDollarsStandard(qrrOverage)}.`;
    }

    return errorMessage;
};
